import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Navbar from '../navigation/Navbar';
import { ProtectedRoute } from '../auth';
import { useAuth } from '../../context/AuthProvider';
import { useRoleModules } from '../../hooks/useRoleModules';
import Loader from '../common/Loader';

type Props = {
    children: React.ReactNode;
};

function DefaultModuleLayout({ children }: Props) {
    const { role } = useAuth();
    const { pathname } = useLocation();
    const moduleData = useRoleModules();

    const selectedModule = useMemo(
        () =>
            moduleData.find(allowedModule =>
                pathname.includes(allowedModule.link),
            ),
        [moduleData, pathname],
    );

    const allowedModules = useMemo(() => {
        return moduleData.map(module => module.value);
    }, [moduleData]);

    if (!role) {
        return (
            <div className="flex w-screen h-[100vh] justify-center items-center">
                <Loader size="lg" isPageLoader />
            </div>
        );
    }

    if (!selectedModule || !allowedModules.includes(selectedModule.value)) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <ProtectedRoute>
            <div className="h-screen w-screen relative overflow-y-hidden bg-[#f8f9fa]">
                <div className="flex flex-col flex-1 relative top-16">
                    {children}
                </div>
            </div>
            <Navbar />
        </ProtectedRoute>
    );
}

export default DefaultModuleLayout;
